module.exports = __webpack_public_path__ + "static/img/Motn-MCS-V.1ee26cf3.jpg";